import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PlayerMutationKeys } from '../../../keys'
import { updatePlayerMainWalletBalance } from '../../services'
import {
	UpdatePlayerMainWalletBalanceRequest,
	UpdatePlayerMainWalletBalanceResponse,
} from '../../../type'

export default function useMutationUpdatePlayerMainWalletBalance(
	props?: UseBaseMutationOptions<
		UpdatePlayerMainWalletBalanceResponse,
		UpdatePlayerMainWalletBalanceRequest
	>,
) {
	return useMutation({
		mutationKey: [PlayerMutationKeys.UpdatePlayerMainWalletBalance],
		mutationFn: (payload) => updatePlayerMainWalletBalance(payload),
		...props,
	})
}
